import { render, staticRenderFns } from "./press_center.vue?vue&type=template&id=41456c7a&scoped=true&"
import script from "./press_center.vue?vue&type=script&lang=js&"
export * from "./press_center.vue?vue&type=script&lang=js&"
import style0 from "./press_center.vue?vue&type=style&index=0&id=41456c7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41456c7a",
  null
  
)

export default component.exports